import React, { useEffect, useState } from "react";
import Canvas from "../reusable-components/Canvas";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import fire from "../../config/firebase";
import PhaseCalculation from "./Phase/phaseCalculationUtil";
//import formatMoneyStr from "../../libs/formatMoneyStr";
import formatMoneyStrFriendly from "../../libs/formatMoneyStrFriendly";
import formatHour from "../../libs/formatHour";
import { colorArray } from "../../libs/color/colorUtils";
import { green } from "@material-ui/core/colors";
const Summary = (props) => {
  // const marginStyleRed = {
  //   color : '#e70a89',
  // }
  // const marginStyleGreen = {
  //   color : '#65a838',
  // }
  const [summaryData, setSummaryData] = useState(null);

  const getDbList = async (tableName) => {
    const ref = fire.database().ref(tableName);
    const refSnapShot = await ref.once("value");
    const val = refSnapShot.val();
    const result = Object.values(val || {});
    return result;
  };
  const init = async () => {
    const colorList = colorArray;
    const { dataType, dataKey } = props;
    let templateName = "estimates";
    if (dataType === "estimates") {
      templateName = "estimates";
    } else if (dataType === "templates") {
      templateName = "templates";
    }
    const currentEstimate = fire.database().ref(templateName + "/" + dataKey);
    const snap = await currentEstimate.once("value");
    const estimates = snap.val();

    const refCompany = fire.database().ref("company");
    const companySnapshot = await refCompany.once("value");
    const company = companySnapshot.val();
    refCompany.off("value");

    const disciplinesList = await getDbList("disciplines");
    const resourcesList = await getDbList("resources");
    const phasesList = await getDbList("phases");

    const calculations = company.arrayItem.map((autocalculation) => {
      autocalculation.figure = parseInt(autocalculation.figure);
      return autocalculation;
    });

    const depMapTemp = new Map();
    const roleMapTemp = new Map();
    const phaseMapTemp = new Map();

    const updateMap = (cMap, obj, keyName, values, defaultVal) => {
      const current = cMap.get(obj[keyName] || "n/a") || {
        cost: 0,
        hours: 0,
        price: 0,
        name: obj[keyName] || defaultVal || "n/a",
      };
      current.hours += values.hours;
      current.cost += values.cost;
      current.price += values.price;
      cMap.set(current.name, current);
    };
    let duplicate = 1;
    estimates?.phases?.sort((a, b) => a.phaseOrder - b.phaseOrder);

    estimates?.phases?.forEach((phase) => {
      const phaseCal = new PhaseCalculation(phase, calculations, estimates);

      const phaseValues = {};
      phaseValues.hours = phaseCal.totalPhaseHours();
      phaseValues.cost = phaseCal.totalPhaseCost();
      phaseValues.price = phaseCal.totalPhasePrice();
      phase.phaseName = phase.phaseName || `Phase-${duplicate++}`;
      updateMap(phaseMapTemp, phase, "phaseName", phaseValues);
      phase?.tasks?.sort((a, b) => a.taskOrder - b.taskOrder);
      phase?.tasks?.forEach((task) => {
        task?.resources?.forEach((resource) => {
          const values = {};
          values.hours = phaseCal.resourceHours(resource, true);
          values.cost =
            phaseCal.resourceCalculate(resource, "cost", true) *
            (task.qty || 1);

          values.price =
            phaseCal.resourceCalculate(resource, "amount", true) *
            (task.qty ? task.qty : 1);
          updateMap(depMapTemp, resource, "caption", values, 'Other');
          updateMap(roleMapTemp, resource, "title", values);
        });
      });
    });

    const fillChart = (mepTemp, nameField, valueField, findColorRef = []) => {
      const arr = [];
      mepTemp.forEach((value) => arr.push(value));

      const curChart = { color: [], name: [], perc: [] };
      let total = 0;
      for (const item of arr) {
        total += item[valueField];
      }
      for (let i = 0; i < arr.length; i++) {
        let itemColor = colorList[i % colorList.length];
        const dbColor = findColorRef.find((d) => d.title === arr[i].name);
        if (dbColor && dbColor.borderColor) {
          itemColor = dbColor.borderColor;
        }
        arr[i].color = itemColor;
        curChart.name.push(arr[i][nameField]);
        if (curChart.name === 'Other') {
          curChart.color.push('#084d4f');
        } else {
          curChart.color.push(itemColor);
        }
        curChart.perc.push(100 * (arr[i][valueField] / total));
      }
      return [arr, curChart];
    };
    const [depMap, depChart] = fillChart(
      depMapTemp,
      "name",
      "price",
      disciplinesList
    );
    const [roleMap, roleChart] = fillChart(
      roleMapTemp,
      "name",
      "price",
      resourcesList
    );
    const [phaseMap, phaseChart] = fillChart(
      phaseMapTemp,
      "name",
      "price",
      phasesList
    );
    const tempSummaryData = {
      depMap,
      depChart,
      roleMap,
      roleChart,
      phaseMap,
      phaseChart,
    };

    setSummaryData(tempSummaryData);
  };
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!summaryData) {
    return null;
  }
  const getCellValue = (val) => {
    if (isNaN(val) || val === undefined || isFinite(val) === false) {
      return 0;
    }
    return val;
  };

  const { depMap, depChart, roleMap, roleChart, phaseMap, phaseChart } =
    summaryData;

  return (
    <div id="summary" className="table col l12 s12">
      {depMap && depMap.length ? null : "No data"}
      {depMap.length > 0 && (
        <div className="row card">
          <div className="col l9 ">
            <table className="bordered summary-table">
              <thead>
                <tr>
                  <th>Discipline</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Hours</th>
                  <th>Cost</th>
                  <th>Price</th>
                  <th>Margin</th>
                </tr>
              </thead>
              <tbody>
                {depMap.map((item, index) => {
                  return (
                    <tr className="row" key={index + item.name}>
                      <td>
                        <FiberManualRecordIcon htmlColor={item.name === 'Other' ? '#084d4f' : item.color} />
                        {item.name}
                      </td>
                      <td>
                        <input
                          defaultValue={formatHour({ number: getCellValue(item.hours) })}
                          placeholder="Hours"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          defaultValue={formatMoneyStrFriendly({ number: getCellValue(item.cost) })}
                          placeholder="Cost"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          defaultValue={formatMoneyStrFriendly({ number: getCellValue(item.price) })}
                          placeholder="Price"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          //style={item.cost > item.price ? marginStyleRed : marginStyleGreen}
                          // defaultValue={formatMoneyStr({
                          //   number: item.price - item.cost,
                          // })}
                          defaultValue={((item.price / item.cost) * 100).toFixed(0) + '%'}
                          placeholder="Margin"
                          className="validate col s9"
                        ></input>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="col l3">
            <Canvas
              perc={depChart.perc}
              name={depChart.name}
              color={depChart.name === 'Other' ? '#084d4f' : depChart.color}
              sectionName={'DISCIPLINE'}
            />
          </div>
        </div>
      )}
      {roleMap.length > 0 && (
        <div className="row card">
          <div className="col l9 ">
            <table className="bordered summary-table">
              <thead>
                <tr>
                  <th>Role</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Hours</th>
                  <th>Cost</th>
                  <th>Price</th>
                  <th>Margin</th>
                </tr>
              </thead>
              <tbody>
                {roleMap.map((item, index) => {
                  return (
                    <tr className="row" key={index}>
                      <td>
                        <FiberManualRecordIcon htmlColor={item.color} />
                        {item.name}
                      </td>
                      <td>
                        <input
                          defaultValue={formatHour({ number: getCellValue(item.hours) })}
                          key={index + item.name}
                          placeholder="Hours"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          defaultValue={formatMoneyStrFriendly({ number: getCellValue(item.cost) })}
                          placeholder="Cost"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          defaultValue={formatMoneyStrFriendly({ number: getCellValue(item.price) })}
                          placeholder="Price"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          // defaultValue={formatMoneyStr({
                          //   number: item.price - item.cost,
                          // })}
                          defaultValue={((item.price / item.cost) * 100).toFixed(0) + '%'}
                          placeholder="4"
                          className="validate col s9"
                        ></input>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="col l3">
            <Canvas
              perc={roleChart.perc}
              name={roleChart.name}
              color={roleChart.color}
              sectionName={'ROLE'}
            />
          </div>
        </div>
      )}
      {phaseMap.length > 0 && (
        <div className="row card">
          <div className="col l9 ">
            <table className="bordered summary-table">
              <thead>
                <tr>
                  <th>Phase</th>
                </tr>
                <tr>
                  <th>Name</th>
                  <th>Hours</th>
                  <th>Cost</th>
                  <th>Price</th>
                  <th>Margin</th>
                </tr>
              </thead>
              <tbody>
                {phaseMap.map((item, index) => {
                  return (
                    <tr className="row" key={index}>
                      <td>
                        <FiberManualRecordIcon htmlColor={item.color} />
                        {item.name || "Phase-" + (index + 1)}
                      </td>
                      <td>
                        <input
                          defaultValue={formatHour({ number: getCellValue(item.hours) })}
                          placeholder="Hours"
                          key={index + item.name}
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          defaultValue={formatMoneyStrFriendly({ number: getCellValue(item.cost) })}
                          placeholder="Cost"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          defaultValue={formatMoneyStrFriendly({ number: getCellValue(item.price) })}
                          placeholder="Price"
                          className="validate col s9"
                        ></input>
                      </td>
                      <td>
                        <input
                          // defaultValue={formatMoneyStr({
                          //   number: item.price - item.cost,
                          // })}
                          defaultValue={((item.price / item.cost) * 100).toFixed(0) + '%'}
                          placeholder="Margin"
                          className="validate col s9"
                        ></input>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="col l3">
            <Canvas
              perc={phaseChart.perc}
              name={phaseChart.name}
              color={phaseChart.color}
              sectionName={'PHASE'}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Summary;
